import { Getter } from "vuex";
import { IState } from './state';

const items: Getter<IState, IState> = (state) => state.items;

export default {
	items
}
